// extracted by mini-css-extract-plugin
export default {"create_post":"CreatePost_create_post__f36-Q"};